import { ConnectProto } from "@racoon/api";
import { compareIds } from "./compare-ids";

/**
 * "Смена 1" / "Смена 2" has no backing field — `DriverOnShift` carries only
 * `tw_start_at`, `created_at` and `id` — so the number is derived from the id: the
 * only key that is always present and never changes as a shift moves through its
 * statuses.
 *
 * `allShiftsOfDay` is every shift the truck has that day, before any filtering: a
 * screen that hides finished shifts must still call the ones it does show by the same
 * number the fleet card gives them. Display order is a separate concern — screens sort
 * their tabs however they like without touching the number.
 *
 * Every screen that labels shifts goes through here. They used to number by array
 * position over differently-built arrays, so the same shift showed up as "Смена 1" on
 * one screen and "Смена 2" on another.
 */
export const shiftNumber = (
  shift: ConnectProto.DriverOnShift,
  allShiftsOfDay: ConnectProto.DriverOnShift[],
) => allShiftsOfDay.filter((other) => compareIds(other.id, shift.id) < 0).length + 1;
